import { formatDistance } from 'date-fns'

export function formatDate(date) {
	return formatDistance(new Date(date), new Date(), {
		includeSeconds: true,
		addSuffix: true
	})
}
